<template>
    <div class="col-lg-7 col-s-12" style="background-color: white; padding: 0; margin: 0;">
        <div class="content">
            <div class="mt-2"></div>
                <component v-bind:is="getActiveContent"></component>
        </div>
    </div>
</template>


<script>
import Windzone from './content/Windzone'
import Gebaeude from './content/Gebaeude'
import Berechnung from './content/Berechnung'
import Unerlaubt from './content/Unerlaubt'

import {mapGetters, mapActions} from "vuex"

export default {
    name: 'Content',
    components: {
        Gebaeude,
        Windzone,
        Berechnung,
        Unerlaubt
    },
    methods: {
        ...mapActions(['changeActiveLink', 'incrementActiveTrigger', 'changeActiveContent']),
        checkInputValidity() {
            return true
        },
        
    },
    computed: mapGetters(['getActiveLink', 'getActiveTrigger', 'getActiveContent', 'isErlaubt']),
    watch:{
        isErlaubt(){
            if(!this.isErlaubt)
            {
                this.$store.commit('setActiveContent', 'unerlaubt')
            }
            else{
                this.$store.commit('setActiveContent', this.getActiveLink)
            }
        }
    }
}
</script>


<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/*********** CONTENT *************/
.content
{
    background: white;
    align-content: center;
    vertical-align: middle;
    height: 85vh;
    position: fixed;
    transition: .2s ease;
    width: 50vw;

}

.content-title
{
   
}

.map-wrapper
{
    align-content: center;
    vertical-align: middle;
    height: 100%;
    position:relative;
}



@media (max-width:992px) {
    .content
    {
        width: 100%;
        height: 30vh;
        z-index: 5;
        position: fixed;
        left:0;
        padding-left: 5%;
    }

}

</style>
